import { inject, Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { SigninApi } from 'sham-components/services';
import { SigninSubmitRequest } from 'sham-components/shared/models/auth';

@Injectable()
export class SigninManager {
  private readonly signinApi = inject(SigninApi);

  async submitForm(payload: SigninSubmitRequest, submitError: any, loading: any) {
    try {
      const result = await firstValueFrom(this.signinApi.signinSeller(payload));
      if (!result) {
        submitError.set('Seller registration failed.');
        return;
      }

      window.localStorage.setItem('seller_id', result.message);
    } catch (error) {
      submitError.set('Unable to submit seller signin form.');
    } finally {
      loading.set(false);
    }
  }
}
